// extracted by mini-css-extract-plugin
module.exports = {"hidden":"routerLoader_hidden__3E5DN","visible":"routerLoader_visible__2WQmU","block":"routerLoader_block__EaY04"};